<template>
    <router-view :key="route.fullPath"/>
    <error-modal 
      v-model="isError" 
      title="エラー" 
      text="中断データの読み込みに失敗しました。中断データを利用せずに学習を開始します。"
      @close="isError = false"
      @close-layer="isError = false"></error-modal>
</template>

<script setup lang="ts">
  import { watch, ref } from 'vue'
  import * as Sentry from "@sentry/browser";
  import { useRoute } from 'vue-router'
  import { useAccountStore } from '@/store/student/account_store';
  import { BreakDataCollection } from '@/models/studyBreakData'
  import { useWorkStore } from '@/store/student/work_store';
  
  const accountStore = useAccountStore()
  const route = useRoute()
  const isError = ref(false)
  watch(
    () => accountStore.userId,
    () => {
      if (accountStore.userId != null){
        accountStore.fetchListSettings()
        // NFR-5116: sync break data with local and pinia store if someone reload page
        try {
            useWorkStore().study_break_data = BreakDataCollection.load();
        } catch (error) {
            // 中断データ読めなかった場合の処理
            Sentry.captureMessage("中断データの読み込みに失敗しました。中断データを利用せずに学習を開始します。", 'warning');
            isError.value = true;
        }
      }
    }
  )
</script>